export default "__VITE_ASSET__DK2dM9XY__"